import { useCallback, useRef, useState } from 'react';
import MasterComponentWraper from '../../../../components/Backend/MasterComponentWraper';
import NavigationHeder from '../../../../components/Navigations/NavigationHeder';
import NewOverlayLoader from '../../../../components/PurchaseRequisition/common/NewOverlayLoader';
import Helper from '../../../../inc/Helper';
import { exportToXlsx, formatJson, getPopupMessageBasedOnStatus, isEmptyObject } from '../../../../inc/Validation';
import Settings from '../../../../inc/Settings';
import axios from 'axios';
import AgGridNew from '../../../../components/grid/ag/ag-grid-new';
import { generateBaseUrl, getLabelFromDropdown, getNewValue, getOptions, gridLinkValueFormat, optionsKeyCreator } from '../../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import ActionsPopup from './ActionsPopup';
import SimpleDropdown from '../../../../components/grid/ag/cellEditor/SimpleDropdown';
import { transformObjectWorkflowActions } from '../../../../inc/TransformerFunctions';
import Api from '../../../../inc/Api';

let gridApi = null;
const WorkflowActions = () => {
    const totalRecords = useRef(0);
    const [exportLoading, setExportLoading] = useState(false);
    const [documentLevelState, setDocumentLevelState] = useState({})
    const [showCreateModal, setShowCreateModal] = useState(false);

    const gridColumnHeader = [
        { field: 'label', filter:'agTextColumnFilter', headerName: 'Label', cellRenderer: (params) => gridLinkValueFormat(params), editable: false },
        { field: 'url', filter:'agTextColumnFilter', headerName: 'Url', editable: false },
        { field: 'payload', valueFormatter: (params) => params.value && Object.keys(params.value).length > 0 ? JSON.stringify(params.value) : '-', filter: false, headerName: 'Payload', editable: false },
        { 
            field: 'method', 
            headerName: 'Method',
            editable: false,
            cellEditor: SimpleDropdown,
            isAllowZero: true,
            minWidth: 180, 
            cellEditorParams: { values: Settings.apiHttpMethods },
            cellDataType: false,
            valueFormatter: (params)=> getLabelFromDropdown(params),
            filter:'agSetColumnFilter',
            filterParams: {
                values: (params) => getOptions(params, Settings.apiHttpMethods),
                keyCreator: (params) => optionsKeyCreator(params, 'value'),
                valueFormatter: params => params.value.label
            }
        }
    ];

    const reloadGrid = () => {
        gridApi?.api?.refreshServerSide({ purge: true });
        gridApi?.api?.deselectAll();
    };

    const onAddBtnClick = () => {
        setShowCreateModal(true);
        setDocumentLevelState({})
    };

    const onDeleteStage = useCallback(async (element) => {
        try {
            let api = Api;
            api.setUserToken()
            const res = await api.
                axios()
                .delete(Settings.baseUrl + `action/${element?.data?.action_id}`)
            const rowNode = gridApi?.api?.getRowNode(element?.data?.action_id)
            if (rowNode) {
                rowNode.setSelected(false)
            }

            setTimeout(() => {
                const transaction = { remove: [element.data] }
                gridApi?.api?.applyServerSideTransaction(transaction)
            }, 200);

            gridApi?.api?.refreshServerSide({ purge: true })
            gridApi?.api?.deselectAll();

            Helper.alert(res?.data?.message, 'success')
        } catch (err) {
            getPopupMessageBasedOnStatus(err)
        }
    }, []);

    const onLabelCellClicked = (event) => {
        if(event.colDef.field === 'label'){
            setDocumentLevelState({...event?.data, payload: !isEmptyObject(event?.data?.payload) ? formatJson(event?.data?.payload) : ''});
            setShowCreateModal(true);
        }
    };

    const exportData = async () => {
        setExportLoading(true);
    
        const apiUrl = `${Settings.baseUrl}action`;
        const params = '';
    
        let pagination = true;
        let defaultAdvanceFilterObj = false; 
        let pageSize = totalRecords.current;
    
        const baseUrl = generateBaseUrl({ gridObj: gridApi, apiUrl, params, pagination, defaultAdvanceFilterObj, pageSize });
        await exportToXlsx({ url: baseUrl, columns: (gridColumnHeader), fileName: "actions_details", apiTokenRequired: false, additionalFunction: transformObjectWorkflowActions });
        
        setExportLoading(false);
    };

    const handleFetchApi = (response) => {
        totalRecords.current = response?.data?.count;
        return {
            rowData: response?.data?.results?.map((item) => ({
                ...item, 
                gridId: `${Date.now()}_${getNewValue()}`
            })),
            rowCount: response?.data?.count 
        }
    };

    return (
        <>
            <NavigationHeder title={`<span style="color:#000;"> Home > </span>  ${'Actions'}`} hideBackButton={true} />
        
            {exportLoading ? <NewOverlayLoader /> : null}
        
            <AgGridNew
                apiUrl={`${Settings.baseUrl}action`}
                pagination={true}
                onCellClicked={onLabelCellClicked}
                columnDefs={gridColumnHeader} 
                onAddClick={onAddBtnClick}
                handleDeleteSelectedRows={onDeleteStage}
                fetchData={handleFetchApi}
                height={500}
                onGridReady={(params) => gridApi = params}
                uniqueField={`action_id`}
                apiTokenRequired={false}
                gridId={'actions-workflow-forms'}
                afterDeleteBtns={
                    <div className="import_sample_template px-2 ms-auto">
                        <button onClick={exportData}>
                            <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
                        </button>
                    </div>
                }
                btnsWrapperStyle="w-100 px-2"
            />
            {showCreateModal && <ActionsPopup reloadParentGrid={reloadGrid} documentLevelState={documentLevelState} setDocumentLevelState={setDocumentLevelState} setShowCreateModal={setShowCreateModal} />}
        </>
    )
}

export default (MasterComponentWraper(WorkflowActions));